import React from 'react';
import { useNavigate } from 'react-router-dom';
import QuotesTable from '../components/QuotesTable';
import BatchUploadButton from '../components/BatchUploadButton';
import { useQuotes } from '../hooks/useQuotes';
import { useAuth } from '../lib/AuthContext';
import { LogOut, Plus, ArrowLeft, MessageSquare } from 'lucide-react';

export default function QuoteTableList() {
  const { quotes, loading, error, updateQuote, deleteQuotes } = useQuotes();
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-gray-600">Loading quotes...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-red-600">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="py-8 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="flex flex-col sm:flex-row gap-4 mb-6">
              <button
                onClick={() => navigate('/')}
                className="inline-flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              >
                <ArrowLeft className="h-4 w-4" />
                Back to Quote View Options
              </button>
              <div className="flex gap-4 sm:ml-auto">
                <BatchUploadButton />
                <button
                  onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSeulAweEFxbcQFDNXFmRA7jyzjU2Ceqt70PQK1xwtu005xy-g/viewform', '_blank')}
                  className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  <MessageSquare className="h-4 w-4" />
                  Feedback
                </button>
                <button
                  onClick={handleSignOut}
                  className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  <LogOut className="h-4 w-4" />
                  Sign out
                </button>
              </div>
            </div>
            <QuotesTable 
              quotes={quotes} 
              onUpdateQuote={updateQuote}
              onDeleteQuotes={deleteQuotes}
            />
          </div>
        </div>
      </div>
    </div>
  );
}